module.exports = __webpack_public_path__ + "img/76268.6bcf99ce.svg";